import { render } from "./TheSecondToolbar.vue?vue&type=template&id=8bbc163e&scoped=true"
import script from "./TheSecondToolbar.vue?vue&type=script&lang=js"
export * from "./TheSecondToolbar.vue?vue&type=script&lang=js"

import "./TheSecondToolbar.vue?vue&type=style&index=0&id=8bbc163e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbc163e"]])

export default __exports__